import { Instagram, ArrowUpRight, Heart } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/matthew-trottstudios';
const INSTAGRAM_URL = 'https://www.instagram.com/matt.trottt';
const LOGO_URL = '/trott-logo.png';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer-section"
      className="bg-[#1E1E2E] py-14 relative overflow-hidden"
    >
      {/* Top border glow animation */}
      <div className="absolute top-0 left-0 right-0 h-px overflow-hidden">
        <div className="h-full w-full bg-gradient-to-r from-transparent via-[#00D4FF] to-transparent animate-pulse-slow" />
      </div>
      
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-32 bg-[#00D4FF]/5 rounded-full blur-3xl" />
      
      <div className="max-w-6xl mx-auto px-5 md:px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Copyright */}
          <div className="flex flex-col md:flex-row items-center gap-5">
            <div className="group cursor-pointer">
              <img 
                src={LOGO_URL} 
                alt="TrottStudios" 
                className="h-[72px] md:h-20 w-auto max-w-[280px] md:max-w-[360px] object-contain transition-all duration-300 group-hover:scale-105" 
              />
            </div>
            <div className="hidden md:block w-px h-6 bg-gray-700" />
            <span className="text-sm text-gray-500 flex items-center gap-1">
              © {currentYear} TrottStudios. Made with <Heart size={12} className="text-[#00D4FF] animate-pulse" /> 
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-contact-link"
              className="flex items-center gap-1 text-sm font-medium text-gray-400 hover:text-[#00D4FF] transition-all duration-300 group underline-animation"
            >
              Contact
              <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="group w-11 h-11 rounded-full bg-[#2D2D3F] flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-[#1E1E2E] transition-all duration-300 hover:scale-110 hover:rotate-6"
              aria-label="Instagram"
            >
              <Instagram size={18} strokeWidth={1.5} className="group-hover:scale-110 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
